import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { SzamlazoService } from '../szamlazo.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  TERMÉKEK, SZOLGÁLTATÁSOK – a számla tételsorába egy kattintással: megnevezés, egység, nettó
 *  egységár, áfakulcs, és hogy termék vagy szolgáltatás (a NAV-nak is megy). */
@Component({
  selector: 'app-szamlazo-termekek',
  templateUrl: './termekek.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../szamlazo-shared.scss'],
})
export class TermekekComponent implements OnInit, OnDestroy {
  lista: any[] = [];
  kereso = '';
  szerk: any = null;
  zar: SzerkZar | null = null;    // a nyitott tétel szerkesztési zárja
  private zarKor = 0;
  private sub?: Subscription;
  constructor(public sz: SzamlazoService, private toast: ToastController, private szerkZar: SzerkZarService) {}
  get u() { return this.sz.aktiv.ugyfelId; }
  get ir() { return this.sz.ir; }

  async ngOnInit() { await this.sz.init(); this.sub = this.sz.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); }
  async frissit() {
    if (!this.u) { this.lista = []; return; }
    try { this.lista = await this.sz.get(`/termekek/${this.u}`); } catch (e: any) { this.lista = []; this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
  }
  get lathato() {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.lista.filter((p) => [p.nev, p.cikkszam, p.vonalkod].some((x) => String(x || '').toLowerCase().includes(k))) : this.lista;
  }
  kulcsNev(k: string) { return this.sz.torzs.afa_kulcsok.find((x) => x.kod === k)?.nev || k; }
  uj() { this.zarElenged(); this.szerk = { id: null, nev: '', fajta: 'SERVICE', egyseg: 'db', egysegar: 0, afa_kulcs: '27', aktiv: true }; }
  nyit(p: any) { this.szerk = { ...p, aktiv: !!Number(p.aktiv), gyariszamos: !!Number(p.gyariszamos) }; this.zarFoglal(String(p.id)); }
  /*  SZERKESZTÉSI ZÁR (components/szerk-zar) – ugyanaz a rekord, mint a Készletkezelés cikke (közös
   *  cikktörzs, ezért ugyanaz a zárfajta). A késve megjött zárat rögtön elengedjük. */
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (!this.ir) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('szamlazo', 'szamlazo_termek', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.zarElenged(); }
  private async ujratolt(id: string) {
    this.lista = await this.sz.get(`/termekek/${this.u}`);
    const p = this.lista.find((x) => String(x.id) === id);
    if (p && String(this.szerk?.id) === id) this.szerk = { ...p, aktiv: !!Number(p.aktiv), gyariszamos: !!Number(p.gyariszamos) };
  }
  async ment() {
    if (this.zar && !this.zar.irhato) return;
    try { await this.sz.post(`/termek/${this.u}`, this.szerk); this.bezar(); await this.frissit(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  szam(v: any) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: 2 }); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2400, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4000, color: 'danger' })).present(); }
}
